import React from "react";
import { Modal } from "@/components/common/Modal";
import { Button } from "@/components/common/Button";
import { AuditLog } from "@/contracts/auth-api.types";
import { formatDate } from "@/utils/formatters";
import { sanitizeHtml } from "@/utils/security";

interface AuditMetadataModalProps {
  isOpen: boolean;
  onClose: () => void;
  log: AuditLog | null;
}

export const AuditMetadataModal: React.FC<AuditMetadataModalProps> = ({ isOpen, onClose, log }) => {
  if (!log) return null;

  const formattedJson = log.metadata ? JSON.stringify(log.metadata, null, 2) : "{}";

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Detalhes do Evento de Auditoria" maxWidth="lg">
      <div className="space-y-4">
        <div className="grid grid-cols-2 gap-3 p-3 bg-gray-50 border border-gray-200 rounded text-xs">
          <div>
            <span className="text-muted block">Ação Executada:</span>
            <code className="font-bold text-primary font-mono text-sm">{log.action}</code>
          </div>
          <div>
            <span className="text-muted block">Data / Hora:</span>
            <span className="font-semibold text-gray-800">{formatDate(log.timestamp)}</span>
          </div>
          <div>
            <span className="text-muted block">Usuário Responsável:</span>
            <span className="font-semibold text-gray-800">{log.user_name}</span>
          </div>
          <div>
            <span className="text-muted block">ID do Usuário (sub):</span>
            <span className="font-mono text-gray-700 truncate block">{log.user_id || "N/A"}</span>
          </div>
        </div>

        <div>
          <h4 className="text-xs font-semibold uppercase text-muted tracking-wider mb-2">
            Metadados do Evento (Payload JSON Seguro)
          </h4>
          <pre
            className="p-3 bg-gray-900 text-green-400 font-mono text-xs rounded-md overflow-x-auto max-h-72 border border-gray-800"
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(formattedJson) }}
          />
        </div>

        <div className="flex justify-end pt-2 border-t border-gray-100">
          <Button variant="secondary" onClick={onClose}>
            Fechar
          </Button>
        </div>
      </div>
    </Modal>
  );
};
